/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';

/**
 * HeroSection Component
 * ---------------------
 * Responsive hero banner with smooth floating 3D M, glowing CTA, and layered background.
 */
export const HeroSection: React.FC = () => {
  const Blocks = require('../../../assets/images/blocks.png');
  const Banner1 = require('../../../assets/images/banner1.jpg');

  return (
    <header
      className="relative bg-[#03010E] text-white flex flex-col justify-center h-[90vh] overflow-hidden"
      data-aos="fade-in"
    >
      {/* 🔹 Background Image */}
      <div className="absolute inset-0">
        <img
          src={Banner1}
          alt="background lines"
          className="w-full h-full object-cover opacity-50"
        />
      </div>

      {/* 🔹 Floating 3D M Image */}
      <div
        className="
          absolute z-10 flex justify-center items-center
          right-[15%] top-[25%]
          md:right-[15%] md:top-[25%]
          sm:top-[60%] sm:right-[5%]
          pointer-events-none
        "
        data-aos="zoom-in"
      >
        <img
          src={Blocks}
          alt="3D M"
          className="
            w-[260px] h-auto md:w-[320px]
            drop-shadow-[0_0_20px_#00D4FF]
            animate-float
            opacity-90 md:opacity-100
          "
        />
      </div>

      {/* 🔹 Text Content */}
      <div className="container mx-auto px-6 md:px-12 z-20 relative">
        <h1 className="text-4xl md:text-6xl font-extrabold leading-tight md:w-[50%] drop-shadow-[0_0_15px_rgba(0,0,0,0.4)]">
          Build a <span className="text-[#00D4FF]">New Future</span> in Occupational{' '}
          <span className="text-[#B7F3FF]">Hygiene</span> With Us.
        </h1>
        <p className="mt-4 text-lg md:text-xl opacity-90 md:w-[45%]">
          Join us in driving something revolutionary.
        </p>

        {/* ✨ Glowing Contact Us Button (no underline, smooth scroll) */}
        <a
          href="#contact"
          className="
    inline-flex items-center gap-2 mt-8 px-8 py-3
    bg-[#00D4FF] text-black font-semibold rounded-full
    hover:bg-[#00b8e6]
    transition-all duration-300
    shadow-[0_0_20px_rgba(0,212,255,0.6)]
    animate-buttonGlow
    scroll-smooth
    no-underline
  "
          style={{ textDecoration: 'none' }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25H4.5a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0L12 13.5 2.25 6.75"
            />
          </svg>
          Contact Us
        </a>
      </div>

      {/* 🌫 Smooth fade overlay into next section */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Gradient that fades bottom into next section tone */}
        <div className="absolute bottom-0 left-0 w-full h-[60%] bg-gradient-to-b from-transparent via-[#021E2A]/80 to-[#03010E]" />

        {/* Optional subtle radial vignette for cinematic depth */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_20%,rgba(0,212,255,0.08),transparent_70%)]" />
      </div>

      {/* ✨ Animations */}
      <style>{`
        @keyframes floatUpDown {
          0% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0); }
        }
        .animate-float {
          animation: floatUpDown 6s ease-in-out infinite;
        }

        @keyframes glowPulse {
          0%, 100% { box-shadow: 0 0 20px rgba(0,212,255,0.4), 0 0 40px rgba(0,212,255,0.3); }
          50% { box-shadow: 0 0 35px rgba(0,212,255,0.8), 0 0 70px rgba(0,212,255,0.5); }
        }
        .animate-buttonGlow {
          animation: glowPulse 4s ease-in-out infinite;
        }

        @media (max-width: 768px) {
          .animate-float {
            animation: floatUpDown 8s ease-in-out infinite;
          }
          header div[data-aos="zoom-in"] {
            opacity: 0.4;
            z-index: 0;
            transform: scale(0.8);
          }
        }
      `}</style>
    </header>
  );
};

export default HeroSection;
